<template>
  <div id="checkout-list" class="overflow-hidden">
    <vs-table ref="table" :data="checkinListItems" style="width: 100%; overflow: auto">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between"></div>
      <template slot="thead">
        <vs-th class="w-1/24">No.</vs-th>
        <vs-th class="w-3/12">User</vs-th>
        <vs-th class="w-2/12" v-if="serviceFeatureActive">Service</vs-th>
        <vs-th class="w-3/24" v-if="staffFeatureActive">Staff</vs-th>
        <vs-th class="w-2/12">Group</vs-th>
        <vs-th class="w-1/12">Type</vs-th>
        <vs-th class="w-3/24">Point</vs-th>
        <vs-th class="w-1/12" v-if="config.check_in && config.check_in.signature_active == 1">Signed</vs-th>
        <vs-th class="w-1/12 p-0">In service</vs-th>
        <vs-th class="w-1/12 p-0" v-if="show_send_sms_to_waiting_customer">SMS</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody id="checkout-table" class="vs-con-loading__container">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            class="item-description"
            @click.native="updateActiveCheckout(tr)"
            :class="{'is-selected': tr.check_out.my_status}"
          >
            <vs-td class="text-lg position-relative">
              <feather-icon icon="EditIcon" svgClasses="w-6 h-5 stroke-current text-primary" class="note-icon" v-if="tr.customer && tr.customer.note && tr.customer.note != ''" />
              {{indextr + 1}}
            </vs-td>
            <vs-td v-if="tr.customer">
              <div>
                <h4 class="item-name font-bold leading-loose p-0">
                  <span
                    class="edit-from-customer-name"
                    @click.stop="updateCustomer(tr)"
                  >{{ tr.customer.full_name }}</span>
                </h4>
                <span class="flex font-bold">
                  <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1 font-bold" />
                  <h6 class="font-bold">{{StringHelper.phoneNumberFormat(tr.customer.phone, true)}}</h6>
                </span>
                <div class="text-sm mt-2">
                  <div>
                    Check in:
                    <span class="text-primary">{{changeFormat(tr.create_at)}}</span>
                  </div>

                  <div
                    class="flex"
                    v-if="tr.customer.last_review && tr.customer.last_review.rating"
                  >
                    Last reviewed:
                    <!-- <span
                      class="text-primary"
                    >{{changeFormat(tr.customer.last_review)}}</span>-->
                    <star-rating
                      :rating="tr.customer.last_review.rating"
                      :read-only="true"
                      :increment="1"
                      class="ml-2"
                      :star-size="12"
                      :show-rating="false"
                    ></star-rating>
                  </div>
                </div>
              </div>
            </vs-td>

            <vs-td v-if="serviceFeatureActive">
              <div v-if="tr.services && tr.services.length > 0">
                <span
                  v-for="(service, index) in tr.services"
                  :key="index"
                  class="pr-2 pb-2 d-inline-block"
                >
                  <!-- <i
                    class="material-icons cursor-pointer bg-primary text-white user-select-none edit-icon" @click.stop="staffDetail"
                  >perm_identity</i>-->
                  <!-- <feather-icon
                    icon="UserIcon"
                    svgClasses="h-10 w-10 mr-1 text-white gradient gradient-primary no-shadow rounded-full p-2 material-icons cursor-pointer"
                    @click.stop="staffDetail(tr)"
                  />-->
                  <!-- Service -->
                  <span
                    class="px-1 bg-warning rounded text-white d-inline-block break-word text-center"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px"
                    @click.stop="changeStatusServiceShowFull(indextr, index)"
                    v-if="!service.show_full"
                  >{{getAcronym(service.name)}}</span>
                  <span
                    class="px-1 bg-warning rounded text-white d-inline-block break-word text-center"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px"
                    @click.stop="changeStatusServiceShowFull(indextr, index)"
                    v-else
                  >{{service.name}}</span>
                </span>
              </div>
              <div v-else>N/A</div>
            </vs-td>

            <vs-td v-if="staffFeatureActive" class="p-0">
              <div @click.stop="openPopupUpdateStaff(tr)" style="padding: 20px;">
                <div style="min-width: 150px" v-if="tr.staffs && tr.staffs.length > 0 || serviceHasStaff(tr) == true">
                  <div class="flex flex-wrap items-center flex-grow justify-center">
                    <div class="px-1" v-for="(staff, index) in tr.staffs" :key="index + 'checkin_staff'">
                      <div class="tooltip" @click.stop="openPopupUpdateStaff(tr)">
                        <vs-button class="tooltip-staff-avatar" @click.stop="openPopupUpdateStaff(tr)">
                          <span class="flex flex-col align-center" style="width: 56px; overflow: hidden;">
                            <vs-avatar
                              :src="staff.image_url"
                              :color="staff.color_code ? staff.color_code : 'primary'"
                              :text="StringHelper.changeFormatAvatar(staff.name)"
                              size="25px"
                              class="text-md"
                            />
                            <span class="text-sm"
                              style="max-width: 50px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
                              @click.stop="openPopupUpdateStaff(tr)"
                            >{{staff.name}}</span>
                          </span>
                        </vs-button>
                        <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{staff.name}}</span>
                      </div>
                    </div>

                    <div class="px-1" v-for="(item, index) in tr.customer_checkin_services" :key="index + 'b'">
                      <div class="tooltip" @click.stop="openPopupUpdateStaff(tr)">
                        <vs-button class="tooltip-staff-avatar" @click.stop="openPopupUpdateStaff(tr)">
                          <span class="flex flex-col align-center" style="width: 56px; overflow: hidden;" v-if="item && item.staff && checkExistedStaff(item.staff, tr.staffs, tr.customer_checkin_services, index)">
                            <vs-avatar
                              :src="item.staff.image_url"
                              :color="item.staff.color_code ? item.staff.color_code : 'primary'"
                              :text="StringHelper.changeFormatAvatar(item.staff.name)"
                              size="25px"
                              class="text-md"
                            />
                            <span class="text-sm"
                              style="max-width: 50px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
                              @click.stop="openPopupUpdateStaff(tr)"
                            >{{item.staff.name}}</span>
                          </span>
                        </vs-button>
                        <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;" v-if="item && item.staff">{{item.staff.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>N/A</div>
              </div>
            </vs-td>

            <!-- <vs-td v-if="staffFeatureActive">
              <div style="min-width: 150px" v-if="tr.staffs && tr.staffs.length > 0 || serviceHasStaff(tr) == true">
                <div class="flex flex-wrap items-center flex-grow justify-center">
                  <div class="px-1" v-for="(staff, index) in tr.staffs" :key="index + 'checkin_staff'">
                    <div class="tooltip" @click.stop>
                      <vs-button class="tooltip-staff-avatar" @click.stop>
                        <span class="flex flex-col align-center" style="width: 56px; overflow: hidden;">
                          <vs-avatar
                            :src="staff.image_url"
                            :color="staff.color_code ? staff.color_code : 'primary'"
                            :text="StringHelper.changeFormatAvatar(staff.name)"
                            size="25px"
                            class="text-md"
                          />
                          <span class="text-sm"
                            style="max-width: 50px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
                            @click.stop
                          >{{staff.name}}</span>
                        </span>
                      </vs-button>
                      <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;">{{staff.name}}</span>
                    </div>
                  </div>

                  <div class="px-1" v-for="(item, index) in tr.customer_checkin_services" :key="index + 'b'">
                    <div class="tooltip" @click.stop>
                      <vs-button class="tooltip-staff-avatar" @click.stop>
                        <span class="flex flex-col align-center" style="width: 56px; overflow: hidden;" v-if="item && item.staff && checkExistedStaff(item.staff, tr.staffs, tr.customer_checkin_services, index)">
                          <vs-avatar
                            :src="item.staff.image_url"
                            :color="item.staff.color_code ? item.staff.color_code : 'primary'"
                            :text="StringHelper.changeFormatAvatar(item.staff.name)"
                            size="25px"
                            class="text-md"
                          />
                          <span class="text-sm"
                            style="max-width: 50px; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
                             @click.stop
                          >{{item.staff.name}}</span>
                        </span>
                      </vs-button>
                      <span class="tooltiptext" style="word-wrap: break-word; word-break: break-word;" v-if="item && item.staff">{{item.staff.name}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>N/A</div>
            </vs-td> -->

            <vs-td v-if="tr.groups">
              <div class="text-primary flex-center flex-wrap break-word" v-if="tr.groups.length > 0">
                <span class="mr-1" v-for="(group, group_index) in tr.groups" :key="group_index">
                  <span v-if="group_index != tr.groups.length - 1">{{group.name}}, </span>
                  <span v-else>{{group.name}}</span>
                </span>
              </div>
              <div class="flex-center" v-else>
                N/A
              </div>
            </vs-td>

            <vs-td v-if="tr.customer">
              <div>
                <vs-alert
                  :color="getMemberTypeColor(tr.customer.type)"
                  class="flex align-center justify-center"
                  style="width: 70px; height: 35px !important"
                >{{tr.customer.type}}</vs-alert>
              </div>
            </vs-td>

            <vs-td v-if="tr.customer" class="text-center">
              <div>{{tr.customer.current_point}} Pts</div>
            </vs-td>

            <td v-if="config.check_in && config.check_in.signature_active == 1">
              <feather-icon
                v-if="tr.attachment"
                @click.stop="openSignaturePopup(tr)"
                icon="CheckCircleIcon"
                class="flex align-center justify-center"
                style="color: #2979FF"
              ></feather-icon>
            </td>

            <vs-td>
              <div class="in-service-switch">
                <vs-switch
                  v-model="tr.check_out.my_status"
                  v-on:click.stop="changeStatusInService(tr)"
                />
              </div>
            </vs-td>
            <vs-td v-if="show_send_sms_to_waiting_customer">
              <div class="in-service-switch">
                <vs-switch :value="true" v-on:click.stop="alertNoSendSMSPermission" v-if="tr.check_out.sms_sent == 2" />
                <vs-switch :value="true" v-on:click.stop="changeStatusSMSSent(tr)" v-if="tr.check_out.sms_sent == 1" />
                <vs-switch :value="false" v-on:click.stop="changeStatusSMSSent(tr)" v-if="tr.check_out.sms_sent == 0" />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- <div v-if="checkinData._meta.pageCount > 1">
      <vs-pagination
        class="custom-pagination"
        :total="checkinData._meta.pageCount"
        v-model="currentPage"
        @click.native="changePage(currentPage, itemsPerPage)"
      ></vs-pagination>
    </div>-->

    <!-- <vs-popup-staff-service-detail :popupStaffDetail="popupStaffDetail" :key="test"></vs-popup-staff-service-detail> -->

    <popup-update-staff :popupUpdateStaffConfig="popupUpdateStaffConfig" :key="'list-update-staff-' + update_staff_key" @UpdateCustomerCheckinStaff="updateCustomerCheckinStaff"></popup-update-staff>

    <signature-popup :popupConfig="popupSignature" :key="signatureKey + 'list'"></signature-popup>
    <vs-popup-info-new-ver
      :popupConfigNew="popupConfigNew"
      :search="search"
      :filter="filter"
      :sort_by="sort_by"
      :key="'new-ver' + abc"
      @UpdateNote="getCheckinList"
    ></vs-popup-info-new-ver>
    <vs-auto-checkout-popup :search="search" :filter="filter" :sort_by="sort_by" :popupConfigNew="popupConfig" :key="'auto' + abc" @UpdateNote="getCheckinList"></vs-auto-checkout-popup>
    <customer-popup-content
      v-if="customer_key != 0"
      :popupConfig="popupCustomerConfig"
      :activeCustomer="activeCustomer"
      :checkoutFilter="checkoutFilter"
      :key="customer_key + 'a'"
      @ClosePopup="popupCustomerConfig.isOpen = false"
      :isFromCheckout="true"
    ></customer-popup-content>
  </div>
</template>

<script>
// import moment from "moment";
import Router from "vue-router";
import Vue from "vue";
import { StringHelper } from "../../models/string_helper";
import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
import StarRating from "vue-star-rating";

Vue.use(Router);

export default {
  name: "vs-checkout-list",
  components: {
    StarRating
  },
  props: {
    //   popupConfig: {
    //       type: Object
    //   },
    // check_in_data: {
    //     type: Array
    // },
    // currentPage: {
    //     type: Number
    // },
    // itemsPerPage: {
    //     type: Number
    // },
    new_ver: {
      type: Boolean
    },
    search: {
      type: String
    },
    filter: {
      type: Object
    },
    sort_by: {
      type: Object
    }
    // checkinData: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
      StringHelper,
      // itemInfo: {},
      temp: true,
      popupStaffDetail: {
        isOpen: false,
        item_info: {}
      },
      popupConfig: {
        isOpen: false,
        item_info: {}
      },
      popupConfigNew: {
        isOpen: false,
        item_info: {}
      },
      popupCustomerConfig: {
        isOpen: false
      },
      popupUpdateStaffConfig: {
        isOpen: false,
        item_info: null
      },
      update_staff_key: 0,
      // checkout_info: {},
      // currentPage: 1,
      // itemsPerPage: 6,
      abc: 0,
      test: 0,
      action_type: "",
      isOpenLoading: false,
      activeCustomer: {},
      customer_key: 0,
      type: "",
      popupSignature: {
        title: "Signature",
        isOpen: false,
        attachment: null
      },
      signatureKey: 0,
      checkoutFilter: {
        keyword: '',
        type: '',
        sort: ''
      }
    };
  },
  computed: {
    checkinListItems() {
      // console.log(this.$store.getters['checkin/checkinListItems']);
      return this.$store.getters["checkin/checkinListItems"];
    },
    checkinData() {
      return this.$store.getters["checkin/checkinList"];
    },
    serviceFeatureActive() {
      return this.$store.getters["auth/config"].service_feature;
    },
    staffFeatureActive() {
      return this.$store.getters["auth/config"].staff_feature;
    },
    productFeatureActive() {
      return this.$store.getters["auth/config"].product_feature;
    },
    show_send_sms_to_waiting_customer() {
      return this.$store.getters["auth/config"].show_send_sms_to_waiting_customer;
    },
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  watch: {
    checkinData: {
      immediate: true,
      deep: true,
      handler() {
        // checkinData.items
        if (
          this.checkinData &&
          this.checkinData.items.length != 0 &&
          this.popupConfigNew.item_info.id
        ) {
          for (let i = 0; i < this.checkinData.items.length; i++) {
            if (
              this.checkinData.items[i].id == this.popupConfigNew.item_info.id
            ) {
              this.popupConfigNew.item_info = this.checkinData.items[i];
              break;
            }
          }
        }
      }
    },
    filter: {
      immediate: true,
      deep: true,
      handler() {
        if (this.filter && this.filter.id != 1) {
          this.checkoutFilter.type = this.filter.name;
        } else {
          this.checkoutFilter.type = '';
        }
        this.getCheckinList();
      }
    },
    search: {
      immediate: true,
      deep: true,
      handler() {
        this.checkoutFilter.keyword = this.search;
        this.getCheckinList();
      }
    },
    sort_by: {
      immediate: true,
      deep: true,
      handler() {
        if(this.sort_by && this.sort_by.id == 2) {
          this.checkoutFilter.sort = this.sort_by.name;
        } else {
          this.checkoutFilter.sort = '';
        }
        this.getCheckinList();
      }
    }
  },
  methods: {
    openPopupUpdateStaff(item) {
      if(item) {
        this.popupUpdateStaffConfig.item_info = item;
        this.popupUpdateStaffConfig.isOpen = true;
        this.update_staff_key++;
      }
    },
    updateCustomerCheckinStaff(obj) {
      if(obj) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.action_type = "Update customer checkin staff";
        this.$store.dispatch('checkin/UPDATE_CUSTOMER_CHECKIN_STAFF', obj).then(() => {
          this.closeLoading();
          this.popupUpdateStaffConfig.isOpen = false;
          this.$vs.notify({
            title: "Notification",
            text: "Update customer checkin staff success",
            color: "success",
            position: "top-right"
          });
          this.getCheckinList();
        }).catch((err) => {
          this.closeLoading();
          this.popupUpdateStaffConfig.isOpen = false;
          this.$vs.notify({
            title: "Notification",
            text: "Update customer checkin staff failed",
            color: "danger",
            position: "top-right"
          });
          console.log('Error: ', err);
        })
      }
    },
    checkExistedStaff(staff, checkin_staff_list, customer_checkin_services, customer_checkin_services_index) {
      if(staff && checkin_staff_list && checkin_staff_list.length > 0) {
        let list = checkin_staff_list;
        for(let i = 0; i < list.length; i++) {
          if(list[i].user_id == staff.user_id) {
            return false;
          }
        }
      }
      if(customer_checkin_services && customer_checkin_services.length > 0) {
        let customer_list = customer_checkin_services;
        for(let j = 0; j < customer_checkin_services_index; j++) {
          if(customer_list[j].staff && customer_list[j].staff.user_id == staff.user_id) {
            return false;
          }
        }
      }
      return true;
    },
    serviceHasStaff(data) {
      // console.log(data);
      if(data && data.customer_checkin_services) {
        for(let i = 0; i < data.customer_checkin_services.length; i++) {
          if(data.customer_checkin_services[i].staff) {
            return true;
          }
        }
      }
      return false;
    },
    updateCustomer(item) {
      if (item && item.customer && item.customer_point) {
        let customer = {
          id: item.customer.id,
          full_name: item.customer.full_name,
          type: item.customer.type,
          visit_count: item.customer.visit_count,
          last_visited: item.customer.last_visited,
          lifetime_point: item.customer_point.lifetime_point,
          current_point: item.customer_point.point,
          is_send_sms: item.customer.is_send_sms,
          email: item.customer.email,
          create_at: item.customer_point.created_at,
          phone: item.customer.phone
        };
        this.activeCustomer = customer;
        this.popupCustomerConfig.isOpen = true;
        this.customer_key++;
      }
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#checkout-table",
        scale: 0.8
      });
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
      this.isOpenLoading = true;
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: this.action_type + " failed",
            acceptText: "OK"
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout(() => {
        this.$vs.loading.close("#checkout-table > .con-vs-loading");
      }, 100);
    },
    changeStatusInService(tr) {
      // console.log(tr);
      const obj = {
        checkout_id: tr.check_out.id,
        status: tr.check_out.status == "pending" ? "inservice" : "pending"
        // page: this.currentPage,
        // 'per-page': this.itemsPerPage
      };
      this.action_type = "update in service status";
      this.openLoadingInDiv();
      this.$store
        .dispatch("checkin/UPDATE_IN_SERVICE_STATUS", obj)
        .then(() => {
          this.closeLoading();
        })
        .catch(() => {
          this.closeLoading();
        });
    },
    alertNoSendSMSPermission() {
      this.$vs.dialog({
        color: "danger",
        title: `Information!`,
        type: "alert",
        text: "This customer has been sent SMS twice!! You're not allowed to do this!!",
        acceptText: 'OK',
        accept: () => {},
      })
    },
    changeStatusSMSSent(tr) {
      if(tr) {
        this.$vs.dialog({
          color: "warning",
          title: `Confirmation!`,
          type: "confirm",
          text: `Do you want to ${tr.check_out.sms_sent == 0 ? 'send' : 'resend'} SMS to this customer?`,
          accept: async () => {
            const obj = {
              checkout_id: tr.check_out.id,
              sms_sent: tr.check_out.sms_sent == 0 ? 1 : 2
            };
  
            this.action_type = "Update SMS sent";
            this.openLoadingInDiv();
            this.$store.dispatch("checkin/UPDATE_SMS_SENT", obj).then(() => {
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: `Send SMS Success`,
                color: "success",
                position: "top-right",
              });
            }).catch(() => {
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: `Send SMS Failed`,
                color: "danger",
                position: "top-right",
              });
            });
          },
          cancel: () => {},
        });
      }
    },
    getCheckinList() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      this.timer = setTimeout(() => {
        const obj = {
          keyword: this.search
        };
        if (this.filter.id != 1) {
          obj.type = this.filter.name;
        }
        if(this.sort_by.id == 2) {
          obj.sort = this.sort_by.name;
        }
        this.$store.dispatch("checkin/GET_CHECKIN_LIST", obj).then(() => {
          this.$vs.loading.close("#app > .con-vs-loading");
        });
      }, 500);
      // this.openLoadingInDiv();
      // const obj = {
      //   // page: this.currentPage,
      //   // "per-page": this.itemsPerPage,
      //   "keyword": this.search,
      // }
      // if(this.filter.id != 1) {
      //   obj.type = this.filter.name;
      // }
      // this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj).then(()=> {
      //   this.closeLoading();
      // });
    },
    // changePage() {
    //   const obj = {
    //     // page: currentPage,
    //     // "per-page": itemsPerPage,
    //     "keyword": this.search,
    //   }
    //   if(this.filter.id != 1) {
    //     obj.type = this.filter.name;
    //   }
    //   this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj);
    // },
    getAcronym(name) {
      let arr_word = name.split(" ");
      let str = "";
      for (let i = 0; i < arr_word.length; i++) {
        str += arr_word[i].charAt(0).toUpperCase();
        if (i == 3) {
          break;
        }
      }
      if (str[str.length - 1] == "$") {
        str = str.substring(0, str.length - 1);
      }
      return str;
    },
    changeStatusServiceShowFull(checkin_index, service_index) {
      // if(this.checkinListItems[checkin_index] && this.checkinListItems[checkin_index].services[service_index]) {
      //   this.$store.dispatch('checkin/CHANGE_STATUS_SERVICE_SHOW_FULL', {checkin_index: checkin_index, service_index: service_index});
      // }
      this.checkinListItems[checkin_index].services[
        service_index
      ].show_full = !this.checkinListItems[checkin_index].services[
        service_index
      ].show_full;
    },
    getGroupString(groups) {
      let str = "";
      for (let i = 0; i < groups.length; i++) {
        str += groups[i].name;
        if (i + 1 != groups.length) {
          str += ", ";
        }
      }
      return str;
    },
    staffDetail(item) {
      this.popupStaffDetail.isOpen = true;
      this.popupStaffDetail.item_info = item;
      this.test++;
    },
    updateActiveCheckout(item) {
      // console.log(item);
      if (this.type == "auto") {
        this.popupConfig.isOpen = true;
      } else {
        this.popupConfigNew.isOpen = true;
      }
      // console.log(item)
      this.popupConfig.item_info = item;
      this.popupConfigNew.item_info = item;
      this.abc++;
    },
    changeFormat(day) {
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    },
    getMemberTypeColor(member_type) {
      if (member_type == "new") return "success";
      if (member_type == "regular") return "primary";
      if (member_type == "atrisk") return "warning";
      if (member_type == "vip") return "danger";
      return "purple";
    },
    openSignaturePopup(data) {
      if (data.attachment != null) {
        this.signatureKey++;
        this.popupSignature.attachment = data.attachment;
        this.popupSignature.title = data.customer.full_name
          ? data.customer.full_name
          : "Signature";
        this.popupSignature.isOpen = true;
      }
    }
  },
  created() {
    // const obj = {
    //   // page: this.currentPage,
    //   // "per-page": this.itemsPerPage,
    //   "keyword": this.search,
    // }
    // this.$store.dispatch('checkin/GET_CHECKIN_LIST', obj);
    this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
      let data = {};
      data = this.$store.state.appSetting.checkoutConfig;
      this.type = data.type;
    });
    this.$emit("ChangeView");
  }
};
</script>
